<div class="view-container">
<mat-card class="company-view-card">
  <mat-card-content class="company-view-card__content">
    @if (company) {
      <div class="company-view-card__header">
        <div class="company-view-card__title-row">
          <div class="company-view-card__icon">
            <mat-icon>business</mat-icon>
          </div>
          <div>
            <h1 class="company-view-card__title">{{ company.name }}</h1>
            @if (companyTypeLabel) {
              <p class="company-view-card__subtitle">{{ companyTypeLabel }}</p>
            }
          </div>
        </div>

        @if (perm.canAddOrEditIndividualOrCompany()) {
          <button
            type="button"
            mat-flat-button
            color="primary"
            class="company-view-card__edit-btn"
            (click)="editMode = !editMode"
          >
            {{ editMode ? 'Details' : 'Edit' }}
          </button>
        }
      </div>
    }

    <div class="company-view-card__actions">
      <button type="button" mat-stroked-button class="company-view-card__action-btn" (click)="backToList()">
        <mat-icon>arrow_back</mat-icon>
        Back to list
      </button>
    </div>

    @if (!editMode && company) {
      <div class="details">
        <table>
          <tr>
            <th>Name</th>
            <td>{{ company.name ? company.name : '-' }}</td>
          </tr>
          <tr>
            <th>Alternative email address</th>
            <td>{{ company.email_alt ? company.email_alt : '-' }}</td>
          </tr>
          <tr>
            <th>Phone number</th>
            <td>{{ company.phone_number ? company.phone_number : '-' }}</td>
          </tr>
          <tr>
            <th>Email</th>
            <td>{{ company.email ? company.email : '-' }}</td>
          </tr>
          <tr>
            <th>Alternative phone number</th>
            <td>{{ company.phone_number_alt ? company.phone_number_alt : '-' }}</td>
          </tr>
          <tr>
            <th>Practice number</th>
            <td>{{ company.practice_number ? company.practice_number : '-' }}</td>
          </tr>
          <tr>
            <th>VAT registration number</th>
            <td>{{ company.vat_registration_number ? company.vat_registration_number : '-' }}</td>
          </tr>
          <tr>
            <th>Sage customer code</th>
            <td>
              @if (missingSageCustomerCode()) {
                <span class="company-view-card__sage-warning">{{ sageCustomerCodeMissingWarning }}</span>
              } @else {
                {{ sageCustomerCodeLabel() }}
              }
            </td>
          </tr>
          @if (isCompanyDistributor()) {
            <tr>
              <th>Invoice mode</th>
              <td>{{ distributorInvoiceModeDisplay() }}</td>
            </tr>
          }
          @if (isCompanyDistributor()) {
            <tr>
              <th>Weekly invoice day</th>
              <td>{{ distributorWeeklyDayDisplay() }}</td>
            </tr>
          }
          <tr>
            <th>Active</th>
            <td>{{ companyActiveDisplay() }}</td>
          </tr>
          <tr>
            <th>Delivery fee</th>
            <td>{{ company.delivery_fee_exempt === true || company.delivery_fee_exempt === 1 ? 'Exempt' : 'Standard' }}</td>
          </tr>
          @if (sageUiEnabled) {
            <tr>
              <th>Sage</th>
              <td>
                @if (isOnSage) {
                  <span class="company-view-card__sage company-view-card__sage--synced">
                    <mat-icon>check_circle</mat-icon>
                    On Sage
                  </span>
                }
                @if (!isOnSage) {
                  <span class="company-view-card__sage">
                    Not on Sage
                    @if (!perm.isViewer()) {
                      <button type="button" mat-stroked-button class="company-view-card__sage-btn ms-2" (click)="addToSage()"
                        [disabled]="addingToSage">
                        <mat-icon>add</mat-icon>
                        {{ addingToSage ? 'Adding…' : 'Add to Sage' }}
                      </button>
                    }
                  </span>
                }
              </td>
            </tr>
          }
        </table>

        @if (address) {
          <h3 class="company-view-card__section-title">Address</h3>
          <table>
            <tr>
              <th>Address</th>
              <td>{{ address.address_1 }}</td>
            </tr>
            <tr>
              <th>Alternative address</th>
              <td>{{ address.address_2 }}</td>
            </tr>
            <tr>
              <th>Building number</th>
              <td>{{ address.building_apt_number }}</td>
            </tr>
            <tr>
              <th>Province</th>
              <td>{{ address.province }}</td>
            </tr>
            <tr>
              <th>City</th>
              <td>{{ address.city }}</td>
            </tr>
            <tr>
              <th>Postcode</th>
              <td>{{ address.postcode }}</td>
            </tr>
            <tr>
              <th>Country</th>
              <td>{{ address.country }}</td>
            </tr>
          </table>
        }

        @if (showDistributor && selectedDistributor) {
          <h3 class="company-view-card__section-title">Distributor</h3>
          <table>
            <tr>
              <th>Name</th>
              <td>{{ selectedDistributor.name ? selectedDistributor.name : '-' }}</td>
            </tr>
            <tr>
              <th>Alternative email address</th>
              <td>{{ selectedDistributor.email_alt ? selectedDistributor.email_alt : '-' }}</td>
            </tr>
            <tr>
              <th>Phone number</th>
              <td>{{ selectedDistributor.phone_number ? selectedDistributor.phone_number : '-' }}</td>
            </tr>
            <tr>
              <th>Email</th>
              <td>{{ selectedDistributor.email ? selectedDistributor.email : '-' }}</td>
            </tr>
            <tr>
              <th>Alternative phone number</th>
              <td>{{ selectedDistributor.phone_number_alt ? selectedDistributor.phone_number_alt : '-' }}</td>
            </tr>
            <tr>
              <th>Practice number</th>
              <td>{{ selectedDistributor.practice_number ? selectedDistributor.practice_number : '-' }}</td>
            </tr>
            <tr>
              <th>VAT registration number</th>
              <td>{{ selectedDistributor.vat_registration_number ? selectedDistributor.vat_registration_number : '-' }}</td>
            </tr>
          </table>
        }
      </div>
    }

    @if (editMode && company) {
      <h3 class="company-view-card__section-title">Edit company details</h3>
      <form class="company-view-card__form mt-3" [formGroup]="companyDetailsForm">
        <div class="row">
          <div class="col-md-6">
            <p>
              <mat-form-field appearance="outline">
                <mat-label>Company name</mat-label>
                <input required data-testid="company-name" type="text" aria-label="Company name" matInput formControlName="companyName">
              </mat-form-field>
            </p>
            <p>
              <mat-form-field appearance="outline">
                <mat-label>Phone number</mat-label>
                <input required data-testid="company-phone-number" formControlName="phoneNumber" matInput>
                @if (companyDetailsForm.get('phoneNumber')?.invalid) {
                  <mat-error>
                    Phone number is invalid
                  </mat-error>
                }
              </mat-form-field>
            </p>
            <p>
              <mat-form-field appearance="outline">
                <mat-label>Alternative phone number</mat-label>
                <input data-testid="company-phone-number-alt" formControlName="phoneNumberAlt" matInput>
                @if (companyDetailsForm.get('phoneNumberAlt')?.invalid) {
                  <mat-error>
                    Alternative phone number is not valid
                  </mat-error>
                }
              </mat-form-field>
            </p>
            <p>
              <mat-form-field appearance="outline">
                <mat-label>Email address</mat-label>
                <input required data-testid="company-email" formControlName="email" matInput>
                @if (companyDetailsForm.get('email')?.invalid) {
                  <mat-error>
                    Email address is required
                  </mat-error>
                }
              </mat-form-field>
            </p>
          </div>
          <div class="col-md-6">
            <p>
              <mat-form-field appearance="outline">
                <mat-label>Alternative email address</mat-label>
                <input data-testid="company-email-alt" formControlName="emailAlt" matInput>
                @if (companyDetailsForm.get('emailAlt')?.invalid) {
                  <mat-error>
                    Alternative email address is not valid
                  </mat-error>
                }
              </mat-form-field>
            </p>
            <p>
              <mat-form-field appearance="outline">
                <mat-label>Practice number</mat-label>
                <input data-testid="company-practice-number" formControlName="practiceNumber" matInput>
                @if (companyDetailsForm.get('practiceNumber')?.invalid) {
                  <mat-error>
                    Practice number is invalid
                  </mat-error>
                }
              </mat-form-field>
            </p>
            <p>
              <mat-form-field appearance="outline">
                <mat-label>VAT registration number</mat-label>
                <input data-testid="company-vat-reg-number" formControlName="vatRegistrationNumber" matInput>
                @if (companyDetailsForm.get('vatRegistrationNumber')?.invalid) {
                  <mat-error>
                    VAT registration number is required
                  </mat-error>
                }
              </mat-form-field>
            </p>
            <p>
              <core-sage-customer-code-field></core-sage-customer-code-field>
              @if (missingSageCustomerCode()) {
                <span class="company-view-card__sage-warning">{{ sageCustomerCodeMissingWarning }}</span>
              }
            </p>
            <p>
              <mat-form-field appearance="outline">
                <mat-label>Company type</mat-label>
                <mat-select required data-testid="company-type" formControlName="companyType">
                  @for (type of companyTypes; track type) {
                    <mat-option [value]="type">
                      {{type.type}}
                    </mat-option>
                  }
                </mat-select>
                @if (companyDetailsForm.get('companyType')?.invalid) {
                  <mat-error>
                    Select company type
                  </mat-error>
                }
              </mat-form-field>
            </p>
            @if (isEditingDistributorType()) {
              <p>
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Invoice mode</mat-label>
                  <mat-select required data-testid="distributor-invoice-mode" formControlName="invoiceMode">
                    @for (opt of invoiceModeOptions; track opt) {
                      <mat-option [value]="opt.value">
                        {{ opt.label }}
                      </mat-option>
                    }
                  </mat-select>
                  @if (companyDetailsForm.get('invoiceMode')?.invalid) {
                    <mat-error>
                      Invoice mode is required
                    </mat-error>
                  }
                </mat-form-field>
              </p>
              @if (companyDetailsForm.get('invoiceMode')?.value === 'GROUP_WEEKLY') {
                <p>
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Weekly invoice day</mat-label>
                    <mat-select required data-testid="distributor-weekly-day" formControlName="weeklyInvoiceDay">
                      @for (d of weeklyInvoiceDayOptions; track d) {
                        <mat-option [value]="d.value">
                          {{ d.label }}
                        </mat-option>
                      }
                    </mat-select>
                    @if (companyDetailsForm.get('weeklyInvoiceDay')?.invalid) {
                      <mat-error>
                        Weekly invoice day is required
                      </mat-error>
                    }
                  </mat-form-field>
                </p>
              }
            }
            <p class="d-flex align-items-center">
              <mat-slide-toggle formControlName="isActive" data-testid="company-active">
                Active
              </mat-slide-toggle>
            </p>
            <p class="d-flex align-items-center">
              <mat-slide-toggle formControlName="deliveryFeeExempt" data-testid="company-delivery-fee-exempt">
                Exempt from delivery fee
              </mat-slide-toggle>
            </p>
          </div>
        </div>
      </form>

      @if (showDistributor) {
        <h3 class="company-view-card__section-title">Distributor</h3>
        <p>
          @if (!selectedDistributor) {
            <button type="button" mat-stroked-button (click)="openSearchDistributorDialog()">
              Select distributor
            </button>
          }
        </p>
        @if (selectedDistributor) {
          <div class="details mt-2">
            <button type="button" mat-stroked-button (click)="deselectDistributor()" class="me-2 my-2">
              <mat-icon>cancel</mat-icon> Remove
            </button>
            <table class="mt-4">
              <tr>
                <th>Name</th>
                <td>{{ selectedDistributor.name ? selectedDistributor.name : '-' }}</td>
              </tr>
              <tr>
                <th>Alternative email address</th>
                <td>{{ selectedDistributor.email_alt ? selectedDistributor.email_alt : '-' }}</td>
              </tr>
              <tr>
                <th>Phone number</th>
                <td>{{ selectedDistributor.phone_number ? selectedDistributor.phone_number : '-' }}</td>
              </tr>
              <tr>
                <th>Email</th>
                <td>{{ selectedDistributor.email ? selectedDistributor.email : '-' }}</td>
              </tr>
              <tr>
                <th>Alternative phone number</th>
                <td>{{ selectedDistributor.phone_number_alt ? selectedDistributor.phone_number_alt : '-' }}</td>
              </tr>
              <tr>
                <th>Practice number</th>
                <td>{{ selectedDistributor.practice_number ? selectedDistributor.practice_number : '-' }}</td>
              </tr>
              <tr>
                <th>VAT registration number</th>
                <td>{{ selectedDistributor.vat_registration_number ? selectedDistributor.vat_registration_number : '-' }}</td>
              </tr>
            </table>
          </div>
        }
      }

      <h3 class="company-view-card__section-title">Edit address</h3>
      <form class="company-view-card__form mt-4" [formGroup]="addressDetailsForm">
        <div class="row">
          <div class="col-md-6">
            <p>
              <mat-form-field appearance="outline">
                <mat-label>Search for a country</mat-label>
                <input required [disabled]="isLoading" type="text"
                  aria-label="Search for a country" matInput formControlName="country"
                  [matAutocomplete]="auto">
                <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                  @for (country of filteredCountriesForIndividual | async; track country) {
                    <mat-option [value]="country.name">
                      {{country.name}}
                    </mat-option>
                  }
                </mat-autocomplete>
                <mat-icon matPrefix>search</mat-icon>
                @if (addressDetailsForm.get('country')?.invalid) {
                  <mat-error>
                    Country is invalid
                  </mat-error>
                }
              </mat-form-field>
            </p>
            <p>
              <mat-form-field appearance="outline">
                <mat-label>Province</mat-label>
                <mat-select required data-testid="individual-province" formControlName="province">
                  @for (province of provinces; track province) {
                    <mat-option value="{{province.name}}">
                      {{province.name}}
                    </mat-option>
                  }
                </mat-select>
                @if (addressDetailsForm.get('province')?.invalid) {
                  <mat-error>
                    Province is invalid
                  </mat-error>
                }
              </mat-form-field>
            </p>
            <p>
              <mat-form-field appearance="outline">
                <mat-label>City</mat-label>
                <input type="text" formControlName="city" matInput />
                @if (addressDetailsForm.get('city')?.invalid) {
                  <mat-error>
                    City is invalid
                  </mat-error>
                }
              </mat-form-field>
            </p>
            <p>
              <mat-form-field appearance="outline">
                <mat-label>Address line 1</mat-label>
                <input required data-testid="individual-address-line-1" formControlName="addressLine1" matInput>
                @if (addressDetailsForm.get('addressLine1')?.invalid) {
                  <mat-error>
                    Address Line 1 is invalid
                  </mat-error>
                }
              </mat-form-field>
            </p>
          </div>
          <div class="col-md-6">
            <p>
              <mat-form-field appearance="outline">
                <mat-label>Suburb</mat-label>
                <input data-testid="individual-address-line-2" formControlName="addressLine2" matInput>
                @if (addressDetailsForm.get('addressLine2')?.invalid) {
                  <mat-error>
                    Suburb is invalid
                  </mat-error>
                }
              </mat-form-field>
            </p>
            <p>
              <mat-form-field appearance="outline">
                <mat-label>Building number</mat-label>
                <input required data-testid="individual-building-apt-number"
                  formControlName="buildingAptNumber" type="number" min="1" matInput>
                @if (addressDetailsForm.get('buildingAptNumber')?.invalid) {
                  <mat-error>
                    Building number is required
                  </mat-error>
                }
              </mat-form-field>
            </p>
            <p>
              <mat-form-field appearance="outline">
                <mat-label>Postcode</mat-label>
                <input required data-testid="individual-postcode" formControlName="postcode" matInput>
                @if (addressDetailsForm.get('postcode')?.invalid) {
                  <mat-error>
                    Postcode is invalid
                  </mat-error>
                }
              </mat-form-field>
            </p>
          </div>
        </div>
      </form>

      <div class="company-view-card__footer">
        <button
          type="button"
          class="company-view-card__btn--primary"
          [disabled]="!canSave"
          (click)="save()"
          color="primary"
          mat-flat-button
        >
          <mat-icon>save</mat-icon> Save
        </button>
      </div>
    }
  </mat-card-content>
</mat-card>
</div>
